import { render, staticRenderFns } from "./TicketStatus.vue?vue&type=template&id=ec7d2e60&scoped=true"
import script from "./TicketStatus.vue?vue&type=script&lang=js"
export * from "./TicketStatus.vue?vue&type=script&lang=js"
import style0 from "./TicketStatus.vue?vue&type=style&index=0&id=ec7d2e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7d2e60",
  null
  
)

export default component.exports